<!-- Kein <form>: der Reiter „Vertrag“ hat eigene Felder, und ein Enter darin
     darf nicht das Formular „Allgemein“ absenden. Enter laeuft ueber
     DialogEnterActionService auf die Primaraktion im Footer (Regel 16). -->
<div [formGroup]="form">
  <nb-card class="form" [class.form--wide]="isSuperAdmin">
    <nb-card-header><h4>Organisation</h4></nb-card-header>
    <nb-card-body>
      <nb-tabset (changeTab)="onTabChange($event)">
        <nb-tab
          tabId="general"
          [tabTitle]="'dialogs.organisation.tabs.general' | translate"
          [active]="activeTab === 'general'"
        >
          <div class="form-group row">
            <label for="company_name" class="label col-sm-3 col-form-label">
              company_name
            </label>
            <div class="col-sm-9">
              <input
                type="text"
                nbInput
                fullWidth
                id="company_name"
                formControlName="company_name"
                [status]="showInputError('company_name') ? 'danger' : 'basic'"
              />
            </div>
          </div>

          <nb-form-field>
            <label for="features" class="label col-sm-3 col-form-label">
              features
            </label>

            <nb-select formControlName="features" multiple="true">
              <nb-option *ngFor="let f of features" [value]="f">
                {{ "enums.organisationFeatures." + f | translate }}
              </nb-option>
            </nb-select>
          </nb-form-field>

          <!-- Super-Admin only: per-client whitelist for templates whose
               access_level is non-public (typically alpha_*). Toggling a
               row grants/revokes that template for the client; on save we
               PUT the full set as the new whitelist. Hidden for non-super-
               admins because the backend would 403 anyway. -->
          <ng-container *ngIf="isSuperAdmin">
            <!-- SCORM-Export im Creator (Migration 085): aus = Kurs-Editor ohne
                 Download, al-filemanager lehnt Export und Paket ab. Vorschau-
                 links bleiben. Nur der Super-Admin (PRIVILEGED_CLIENT_FIELDS). -->
            <hr />
            <h6>{{ 'dialogs.organisation.creatorExport.title' | translate }}</h6>
            <p class="hint">{{ 'dialogs.organisation.creatorExport.hint' | translate }}</p>
            <nb-toggle formControlName="creator_export_allowed">
              {{ 'dialogs.organisation.creatorExport.label' | translate }}
            </nb-toggle>

            <hr />
            <h6>{{ 'pages.admin.templateAccess.title' | translate }}</h6>
            <p class="hint">{{ 'pages.admin.templateAccess.hint' | translate }}</p>
            <div *ngIf="!templateAccessLoaded" class="muted">
              {{ 'pages.admin.templateAccess.loading' | translate }}
            </div>
            <div *ngIf="templateAccessLoaded && templateAccess.length === 0" class="muted">
              {{ 'pages.admin.templateAccess.empty' | translate }}
            </div>
            <div class="template-access-list">
              <label
                *ngFor="let t of templateAccess"
                class="template-access-row"
              >
                <nb-checkbox
                  [checked]="t.granted"
                  (checkedChange)="toggleTemplate(t)"
                ></nb-checkbox>
                <div class="template-access-meta">
                  <span class="template-access-name">{{ t.name }}</span>
                  <span *ngIf="t.description" class="template-access-desc">
                    {{ t.description }}
                  </span>
                </div>
              </label>
            </div>
          </ng-container>
        </nb-tab>

        @if (isSuperAdmin && data) {
          <nb-tab
            tabId="contract"
            [tabTitle]="'dialogs.organisation.tabs.contract' | translate"
            [active]="activeTab === 'contract'"
          >
            <!-- Erst beim ersten Oeffnen anlegen: der Reiter laedt Vertrag,
                 Vorlagen und Verlauf, das braucht nicht jeder Dialog. -->
            @if (contractTabOpened) {
              <app-contract-editor
                [clientId]="data.id"
                [companyName]="data.company_name"
                (changed)="contractChanged = true"
              ></app-contract-editor>
            }
          </nb-tab>
        }
      </nb-tabset>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="close()"
      >
        {{ (activeTab === "contract" ? "buttons.close" : "buttons.cancel") | translate }}
      </button>
      @if (activeTab === "contract") {
        <div class="footer-actions">
          @if (contractIsActive) {
            <button
              type="button"
              nbButton
              status="basic"
              class="btn-caution"
              [disabled]="contractBusy"
              [nbSpinner]="contractEnding"
              (click)="endContract()"
            >
              {{ "dialogs.contract.buttons.end" | translate }}
            </button>
          }
          <button
            type="button"
            nbButton
            status="primary"
            [disabled]="contractBusy || !contractReady"
            [nbSpinner]="contractSaving"
            (click)="saveContract()"
          >
            {{
              (contractIsActive ? "dialogs.contract.buttons.save" : "dialogs.contract.buttons.activate")
                | translate
            }}
          </button>
        </div>
      } @else {
        <button type="button" nbButton status="primary" (click)="onSubmit()">
          {{ "buttons.save" | translate }}
        </button>
      }
    </nb-card-footer>
  </nb-card>
</div>
